<template>
  <div class="itemCont">
    <div class="icon-flag">免审</div>
    <div class="itemImg">
      <el-image lazy :src="item.image || avater" alt="" style="width: 180px; height: 180px; padding: 15px 0px" />
    </div>
    <el-tooltip class="item" effect="dark" :content="(item.brand || '') + item.name" placement="top">
      <div class="itemBox name">
        {{ item.brand || '' }}
        {{ item.name || "" }}
      </div>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" :content="item.factory" placement="top">
      <div class="itemBox factory">
        <span>厂家</span> {{ item.factory || "" }}
      </div>
    </el-tooltip>
    <p class="itemBox factory">
      <span>批文</span> {{ item.approvalNumber || "" }}
    </p>
    <div class="itemBox factory">
      <span>规格</span>{{ item.specification || "" }}
    </div>
    <div class="itemBox factory" v-if="item.origin">
      <span>产地</span>{{ item.origin || "" }}
    </div>
    <div class="itemBox factory">
      <span>编码</span>{{ item.goodsCode || "" }}
    </div>
  </div>
</template>
<script>
import avater from "/public/img/default.png";
export default {
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data () {
    return {
      avater: avater,
    };
  },
  methods: {
    //
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.itemCont {
  width: calc(20% - 10px);
  height: 336px;
  border: 1px solid #ccc;
  margin: 0 0 8px 8px;
  border-radius: 4px;
  position: relative;

  .icon-flag {
    position: absolute;
    left: 0;
    top: 0;
    width: 52px;
    height: 24px;
    background: #32bf78;
    border-radius: 4px 0px 4px 0px;
    z-index: 1;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &:hover {
    border: 2px solid;
    border-color: $borderColorActive;
  }

  .factory {
    color: #595959;
    font-size: 14px;
    height: 22px;

    span {
      color: #8c8c8c;
      margin-right: 4px;
    }
  }

  .itemBox {
    padding: 0px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 22px;
    margin: 0;
  }

  .name {
    display: block !important;
    font-size: 16px;
    font-weight: 600;
    padding: 4px 10px;
  }

  .itemImg {
    height: 180px;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .price {
    font-weight: 700;
    justify-content: end;
  }

  .shopCar {
    margin-top: 5px;
    justify-content: center;

    .el-button {
      width: 100%;
      padding: 8px 20px;
    }
  }
}

::v-deep .el-button {
  span {
    margin-left: 0px !important;
  }
}
</style>
